import {
	getOutputOfDevice,
	getOutputOfJobOrder,
	getOutputOfWorker,
	getOutputOfWorkingShift,
	getOutputOfWorkshop,
	getOutputOfTech,
	getYieldOfDevice,
	getYieldOfJobOrder,
	getYieldOfShift,
	getYieldOfWorkshop,
	getYieldOfWorker,
	getYieldOfTech,
	getMeterYieldOfDevice,
	getMeterYieldOfJobOrder,
	getMeterYieldOfWorkingShift,
	getMeterYieldOfWorkshop,
	getMeterYieldOfWorker,
	getMeterYieldOfTech,
	getAdjustTimeOfDevice,
	getAdjustTimeOfJobOrder,
	getAdjustTimeOfShift,
	getAdjustTimeOfWorker,
	getAdjustTimeOfWorkshop,
	getAdjustTimeOfTech,
	getAdjustMeterOfDevice,
	getAdjustMeterOfJobOrder,
	getAdjustMeterOfShift,
	getAdjustMeterOfWorkshop,
	getAdjustMeterOfWorker,
	getAdjustMeterOfTech,
	getDefectTypeCountOfDevice,
	getDefectTypeCountOfJobOrder,
	getDefectTypeCountOfShift,
	getDefectTypeCountOfWorkshop,
	getDefectTypeCountOfWorker,
	getDefectTypeCountOfTech,
} from '@/service/reportService'
import { jtInfoRequest } from '@/network/requests/jtInfo'
import { jobOrderRequest, getWorkers } from '@/network/requests/jobOrder'
import { techInfoRequest } from '@/network/requests/techInfo'
import { workshopRequest } from '@/network/requests/workshop'
import { getFactoryUsers } from '@/network/api/user'
import { getDBName } from '@/network/config'
import { $in, like } from '@/network/util/QueryBuilder'

function isInteger(n) {
	return parseInt(n) == parseFloat(n)
}

function isFloat(n) {
	return parseInt(n) < parseFloat(n)
}

/**
 * 生产信息统计类。
 */
class OtherStat {
	/**
	 * 统计维度键值对。
	 */
	dimensionKeyValue = {
		1: '设备',
		2: '工单',
		3: '人员',
		4: '工艺',
		5: '车间',
		6: '班次',
	}

	/**
	 * 实例化类；根据传入的维度和指标，会调用 reportService.js 中相对应写好的接口。
	 *
	 * @param {Number} dimension    统计维度（1：设备，2：工单，3：人员，4：工艺，5：车间，6：班次）。
	 * @param {Number} quota        统计指标（1：产量，2：良率（米数），3：调机时间，4：调机米数，5：缺陷，6：良率（张数））。
	 * @param {Array}  dateGroups   日期分组。
	 * @param {String} workshopId   车间Id，如果指定了车间，统计维度需要根据车间进行过滤。
	 */
	constructor(dimension, quota, dateGroups, workshopId) {
		this.dimension = dimension
		this.dimensionName = this.dimensionKeyValue[dimension]
		this.quota = quota
		this.dateGroups = dateGroups
		this.workshopId = workshopId
	}

	/**
	 * 获取统计数据。
	 *
	 * @param {Array} dateColumns   日期列集合。
	 */
	async getData(dateColumns) {
		var task = this._getStatMethods(this.dateGroups)

		console.log('dateColumns', dateColumns)

		if (!task) {
			return {
				chartData: [],
				chartTable: {},
			}
		}

		var data = await task

		console.log('data', data)

		var chartData = {
			columns: ['时间', ...this.columnNames],
			rows: [
				...dateColumns.map(t => {
					return { 时间: t }
				}),
			],
		}

		var chartTable = {
			columns: [
				{ text: `${this.dimensionName}\\时间` },
				...dateColumns.map(t => {
					return { text: t }
				}),
			],
			rows: [],
		}

		if (!data) {
			return {
				chartData: [
					{
						columns: [],
						rows: [],
					},
				],
				chartTable: {
					columns: [],
					rows: [],
				},
			}
		}

		if (this.quota == 5) {
			//缺陷分布，单独处理，对数据进行合并。
			console.log('缺陷分布', data)
			var result = this._parseDefectType(data)
			console.log(result)

			return result
		} else {
			console.log('数据已获取开始进行统计')
			//遍历行(维度)。
			data.forEach((items, i) => {
				var columnName = this.columnNames[i]

				var columns = []
				columns.push({
					text: columnName,
				})

				//遍历列（按日期分组的指标结果值）。
				items.forEach((v, j) => {
					var value = v //图表中的值。
					var cell_value = '' //单元格的文本内容。

					switch (this.quota) {
						case 3:
							{
								value = v / 1000 > 0 ? (v / 1000).toFixed(3) : v / 1000
								cell_value = value
							}
							break

						case 1:
						case 4:
							{
								//产量,调机米数单位为毫米，需要转换成米。
								value = v / 1000
								cell_value = value
							}
							break
						case 2:
						case 6:
							{
								//良率，良率的显示需要用百分比。
								value = v * 100 > 0 && v * 100 < 100 ? (v * 100).toFixed(2) : v / 100
								cell_value = value + '%'
							}
							break
						default:
							{
								cell_value = value
							}
							break
					}

					columns.push({
						text: cell_value,
					})

					chartData.rows[j][columnName] = value
				})

				chartTable.rows.push({
					columns: columns,
				})
			})

			console.log('统计结束')

			return {
				chartData: [chartData],
				chartTable,
			}
		}
	}

	/**
	 * 通用方法，获取统计方法。
	 *
	 * @param {Array} params
	 */
	_getStatMethods(dateGroups) {
		var task = null
		switch (this.dimension) {
			case 1: //设备统计
				task = this._getDeviceStat(dateGroups)
				break
			case 2: //工单统计
				task = this._getOrderStat(dateGroups)
				break
			case 3: //人员统计
				task = this._getWorkerStat(dateGroups)
				break
			case 4: //工艺统计
				task = this._getTechStat(dateGroups)
				break
			case 5: //车间统计
				task = this._getWorkshopStat(dateGroups)
				break
			case 6: //班次统计
				task = this._getClassesStat(dateGroups)
				break
		}

		return task
	}

	/**
	 * 按设备统计。
	 *
	 * @param {Array} dateGroups
	 */
	async _getDeviceStat(dateGroups) {
		console.log('日期组', dateGroups)

		var filter = undefined
		//车间过滤。
		if (this.workshopId) {
			filter = {
				workshop_id: this.workshopId,
			}
		}

		//查询所有设备。
		var jt_list = await jtInfoRequest.queryAll(filter)
		//设备Id集合
		var jt_id_list = jt_list.map(t => t._id.$oid)
		//设备名称集合。
		var jt_name_list = jt_list.map(t => t.name)

		//设置当前表格列名称集合。
		this.columnNames = jt_name_list

		//根据不同的指标调用不同的统计方法。
		var task = null
		switch (this.quota) {
			case 1:
				task = getOutputOfDevice(jt_id_list, dateGroups)
				break
			case 2:
				task = getYieldOfDevice(jt_id_list, dateGroups)
				break
			case 3:
				task = getAdjustTimeOfDevice(jt_id_list, dateGroups)
				break
			case 4:
				task = getAdjustMeterOfDevice(jt_id_list, dateGroups)
				break
			case 5:
				task = getDefectTypeCountOfDevice(jt_id_list, this._getDefectTypeStatTimeSection(dateGroups))
				break
			case 6:
				task = getMeterYieldOfDevice(jt_id_list, dateGroups)
				break
		}

		return task
	}

	/**
	 * 按工单统计。
	 * @param {Array} dateGroups
	 */
	async _getOrderStat(dateGroups) {
		var filter = undefined

		//车间过滤(因为工单不能直接关联到车间，只能先查询车间下所有的设备，然后再统计)。
		if (this.workshopId) {
			//查询车间所有机台。
			var jt_list = await jtInfoRequest.queryAll({ workshop_id: this.workshopId })
			filter = {
				jt_id: $in(jt_list.map(t => t._id.$oid)),
			}
		}

		//按工单统计。
		var order_list = await jobOrderRequest.queryAll(filter)
		var order_id_list = order_list.map(t => t._id.$oid)
		var order_code_list = order_list.map(t => (t.code == null ? '' : t.code))

		//设置当前表格列名称集合。
		this.columnNames = order_code_list

		//根据不同的指标调用不同的统计方法。
		var task = null
		switch (this.quota) {
			case 1:
				task = getOutputOfJobOrder(order_id_list, dateGroups)
				break
			case 2:
				task = getYieldOfJobOrder(order_id_list, dateGroups)
				break
			case 3:
				task = getAdjustTimeOfJobOrder(order_id_list, dateGroups)
				break
			case 4:
				task = getAdjustMeterOfJobOrder(order_id_list, dateGroups)
				break
			case 5:
				task = getDefectTypeCountOfJobOrder(order_id_list, this._getDefectTypeStatTimeSection(dateGroups))
				break
			case 6:
				task = getMeterYieldOfJobOrder(order_id_list, dateGroups)
				break
		}

		return task
	}

	/**
	 * 按照人员统计。
	 * @param {*} params
	 */
	async _getWorkerStat(dateGroups) {
		var worker_id_list = []
		var worker_name_list = []

		var dbName = getDBName()

		//TODO 人员暂时不能按照车间进行区分。

		//获取所有工厂人员。
		var factoryUsersResponse = await getFactoryUsers(dbName)
		if (factoryUsersResponse.success) {
			factoryUsersResponse.result.forEach(p => {
				worker_id_list.push(p.id)
				worker_name_list.push(p.realname)
			})

			console.log('getFactoryUsers', worker_name_list)
		}

		this.columnNames = worker_name_list
		if (worker_id_list.length == 0) {
			return null
		}

		var task = null
		switch (this.quota) {
			case 1:
				task = getOutputOfWorker(worker_id_list, dateGroups)
				break
			case 2:
				task = getYieldOfWorker(worker_id_list, dateGroups)
				break
			case 3:
				task = getAdjustTimeOfWorker(worker_id_list, dateGroups)
				break
			case 4:
				task = getAdjustMeterOfWorker(worker_id_list, dateGroups)
				break
			case 5:
				task = getDefectTypeCountOfWorker(worker_id_list, this._getDefectTypeStatTimeSection(dateGroups))
				break
			case 6:
				task = getMeterYieldOfWorker(worker_id_list, dateGroups)
				break
		}

		return task
	}

	/**
	 * 按照工艺进行统计，暂未实现。
	 * @param {*} params
	 */
	async _getTechStat(dateGroups) {
		//TODO 工艺暂时不能按照车间进行区分。

		//按工艺统计。
		var tech_list = await techInfoRequest.queryAll()
		var tech_id_list = tech_list.map(t => t._id.$oid)
		var tech_name_list = tech_list.map(t => t.name)

		console.log('工艺列表', tech_list)

		this.columnNames = tech_name_list

		var task = null
		switch (this.quota) {
			case 1:
				task = getOutputOfTech(tech_id_list, dateGroups)
				break
			case 2:
				task = getYieldOfTech(tech_id_list, dateGroups)
				break
			case 3:
				task = getAdjustTimeOfTech(tech_id_list, dateGroups)
				break
			case 4:
				task = getAdjustMeterOfTech(tech_id_list, dateGroups)
				break
			case 5:
				task = getDefectTypeCountOfTech(tech_id_list, this._getDefectTypeStatTimeSection(dateGroups))
				break
			case 6:
				task = getMeterYieldOfTech(tech_id_list, dateGroups)
				break
		}

		return task
	}

	/**
	 * 按照车间进行统计。
	 * @param {Array} dateGroups
	 */
	async _getWorkshopStat(dateGroups) {
		var workshop_name_list = []
		var workshop_id_list = []

		//车间过滤。
		if (this.workshopId) {
			var workshopInfo = (await workshopRequest.getDocumentById(this.workshopId)).data
			workshop_name_list = [workshopInfo.name]
			workshop_id_list = [workshopInfo._id.$oid]
		} else {
			var workshops = await workshopRequest.queryAll()
			workshop_id_list = workshops.map(t => t._id.$oid)
			workshop_name_list = workshops.map(t => t.name)
		}

		this.columnNames = workshop_name_list

		var task = null
		switch (this.quota) {
			case 1:
				task = getOutputOfWorkshop(workshop_id_list, dateGroups)
				break
			case 2:
				task = getYieldOfWorkshop(workshop_id_list, dateGroups)
				break
			case 3:
				task = getAdjustTimeOfWorkshop(workshop_id_list, dateGroups)
				break
			case 4:
				task = getAdjustMeterOfWorkshop(workshop_id_list, dateGroups)
				break
			case 5:
				task = getDefectTypeCountOfWorkshop(workshop_id_list, this._getDefectTypeStatTimeSection(dateGroups))
				break
			case 6:
				task = getMeterYieldOfWorkshop(workshop_id_list, dateGroups)
				break
		}

		return task
	}

	/**
	 * 按照班次进行统计。
	 * @param {Array} dateGroups
	 */
	_getClassesStat(dateGroups) {
		//TODO 班次暂时不能按照车间进行区分。

		//按班次统计。
		this.columnNames = ['白班', '夜班']
		var workshiftList = [0, 1]
		var task = null
		switch (this.quota) {
			case 1:
				task = getOutputOfWorkingShift(workshiftList, dateGroups)
				break
			case 2:
				task = getYieldOfShift(workshiftList, dateGroups)
				break
			case 3:
				task = getAdjustTimeOfShift(workshiftList, dateGroups)
				break
			case 4:
				task = getAdjustMeterOfShift(workshiftList, dateGroups)
				break
			case 5:
				task = getDefectTypeCountOfShift(workshiftList, this._getDefectTypeStatTimeSection(dateGroups))
				break
			case 6:
				task = getMeterYieldOfWorkingShift(workshiftList, dateGroups)
				break
		}

		return task
	}

	/**
	 * 缺陷类型统计转用：根据时间组获取开始时间和结束时间。
	 * @param {*} dateGroups
	 */
	_getDefectTypeStatTimeSection(dateGroups) {
		return {
			startTime: dateGroups[0].startTime,
			endTime: dateGroups[dateGroups.length - 1].endTime,
		}
	}

	/**
	 * 缺陷类型统计专用。
	 * @param {*} data
	 */
	_parseDefectType(data) {
		let index = 0

		//所有缺陷类型。
		var types = []

		var combinedData = {}

		//第一次遍历，获取所有缺陷类型，并将缺陷类型合并。
		for (const p in data) {
			var defectTypeObject = {}
			//遍历每个维度对应的缺陷类型数量。
			for (let j = 0; j < data[p].length; j++) {
				const element = data[p][j]

				//合并缺陷类型和数量。
				var display = element.display
				if (!display) {
					continue
				}

				//如果缺陷类型已存在，则对缺陷类型进行合计。
				if (display in defectTypeObject) {
					defectTypeObject[display] += element.count
				} else {
					defectTypeObject[display] = element.count
				}

				if (types.indexOf(display) == -1) {
					types.push(display)
				}
			}

			combinedData[p] = defectTypeObject
		}

		var chartData = {
			columns: ['缺陷类型', '数量'],
			rows: [],
			title: this.dimensionName + '汇总',
		}

		var chartTable = {
			columns: [
				{ text: `${this.dimensionName}\\缺陷类型` },
				...types.map(t => {
					return { text: t }
				}),
			],
			rows: [],
		}

		var chartDataList = []
		//第二次遍历，构造表格数据。
		for (const p in combinedData) {
			const columns = []

			//类型名称，比如：（设备名称，工单名称，工艺...）
			const columnName = this.columnNames[index]
			columns.push({
				text: columnName,
			})

			var chartDataItem = { columns: ['缺陷类型', '数量'], rows: [], title: columnName }
			//遍历所有缺陷类型。
			for (const t of types) {
				let count = 0
				const value = combinedData[p][t]
				if (value) {
					count += value
				}

				columns.push({
					text: count,
				})

				chartDataItem.rows.push({
					缺陷类型: t,
					数量: count,
				})
			}

			chartTable.rows.push({
				columns: columns,
			})

			chartDataList.push(chartDataItem)

			index++
		}

		var totalColumns = [
			{
				text: '汇总',
			},
		]

		//汇总数据
		//遍历所有缺陷类型。
		for (const t of types) {
			let count = 0
			for (const p in combinedData) {
				const value = combinedData[p][t]
				if (value) {
					count += value
				}
			}

			chartData.rows.push({
				缺陷类型: t,
				数量: count,
			})

			totalColumns.push({
				text: count,
			})
		}

		chartTable.rows.push({ columns: totalColumns })
		chartDataList.push(chartData)

		return {
			chartData: chartDataList,
			chartTable,
		}
	}
}

export default OtherStat
